/** @format */

import { Link } from "react-router-dom";
import React, { useState } from "react";
import usePermissions from "../../../components/permissions/permission";

const Approval_stage_one = () => {

  const { hasPermission } = usePermissions();

  return (
    <div className="h-screen overflow-y-auto bg-background">
      <div className="ml-[6%] mt-[5%] mr-[3%]">
        <p className="text-headerColor text-[28px] font-semibold">
        Approval Satge One
        </p>
        <div className="grid grid-cols-7 gap-8 mt-8">
          {/* card1 */}

          {hasPermission(6005) && (
            <div className="bg-white w-[220px] h-[200px] rounded-[30px] p-4 flex flex-col justify-between">
              <div className="text-[20px] font-bold">
                <p>Sample Testing Report</p>
              </div>
              <div className="flex justify-center">
                <Link to="/quality-management/approval-one/sample-testing-report">
                  <div className="bg-primary text-white p-2 rounded-[20px]">
                    Click Here
                  </div>
                </Link>
              </div>
            </div>
          )}


          {/* card2 */}
          {hasPermission(6006) && (
            <div className="bg-white w-[220px] h-[200px] rounded-[30px] p-4 flex flex-col justify-between">
              <div className="text-[20px] font-bold">
                <p>Manual  Disposal</p>
              </div>
              <div className="flex justify-center mt-3">
                <Link to="/quality-management/approval-one/manual-disposal">
                  <div className="bg-primary text-white p-2 rounded-[20px]">
                    Click Here
                  </div>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Approval_stage_one;
